import { AbstractControl } from '@angular/forms';

export function isValidEmail(control: AbstractControl) {
  let pattern = /^[A-Za-z0-9._+-]+@[A-Za-z0-9._+-]+\.[A-Za-z0-9_+-]+$/;
    if (control.value && !pattern.test(control.value)) {
        return { 'invalidEmail': true };
    }
    return null
};
